import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faChevronRight,
  faChevronDown,
  faEnvelope,
  faAddressCard,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { setAttendees } from "../../../store/slices/eventSlice";
import {
  Description,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { QRCodeCanvas } from "qrcode.react";
import { useAxiosInstance } from "../../../services/Interceptor";
import { GetCashToken } from "../../../services/PaymentService";
import { GetEventAuditList } from "../../../services/EventsService";
import AthleteContactModal from "../../../components/contactinfo";
import SendEmailModal from "../../../components/SendEmailModal";

export default function Attendees({
  attendees,
  eventId,
  eventName,
  handleAttendeesClick,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const dispatch = useDispatch();
  const [attendeesList, setAttendeesList] = useState([]);

  const [height, setHeight] = useState(window.innerHeight);
  const adjustedHeight = height - 395;
  const apiInstance = useAxiosInstance();
  const [open, setOpen] = useState(false);
  const [emailOpen, setEmailOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(false);
  const actionMenuRef = useRef(null);

  useEffect(() => {
    if (attendees) {
      setAttendeesList(attendees);
    }
  }, [attendees]);

  const handleSearch = (e) => {
    const results = attendees.filter(
      (item) =>
        item.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item.lastname.toLowerCase().includes(e.target.value.toLowerCase()) ||
        item.position.toLowerCase().includes(e.target.value.toLowerCase()) ||
        (item.jerseyNumber &&
          item.jerseyNumber.toString().includes(e.target.value)),
    );
    setAttendeesList(results);
  };

  useEffect(() => {
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  useEffect(() => {
    if (!isActionMenuOpen) return;

    const handleClickOutside = (event) => {
      if (!actionMenuRef.current?.contains(event.target)) {
        setIsActionMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isActionMenuOpen]);

  const updateHeight = () => {
    setHeight(window.innerHeight);
  };

  const handleDownloadCsv = async () => {
    setIsDownloading(true);
    try {
      const data = await GetEventAuditList(apiInstance, eventId);
      const yn = (v) => (v ? "Yes" : "No");

      const headers = [
        "First Name",
        "Last Name",
        "Jersey #",
        "Profile Picture",
        "Meas: Height",
        "Vid: Height",
        "Meas: Weight",
        "Meas: Wingspan",
        "Vid: Wingspan",
        "Vid: Overhead Squat",
        "Meas: Hand",
        "Meas: Foot",
        "40yd A1 10yd",
        "Vid: 40yd A1 10yd",
        "40yd A1 20yd",
        "40yd A1 40yd",
        "Vid: 40yd A1 40yd",
        "40yd A2 10yd",
        "Vid: 40yd A2 10yd",
        "40yd A2 20yd",
        "40yd A2 40yd",
        "Vid: 40yd A2 40yd",
        "Bench Press",
        "Vid: Bench Press",
        "Vertical Jump",
        "Vid: Vertical Jump",
        "Broad Jump A1",
        "Vid: Broad Jump A1",
        "Broad Jump A2",
        "Vid: Broad Jump A2",
        "20yd Shuttle A1",
        "Vid: 20yd Shuttle A1",
        "20yd Shuttle A2",
        "Vid: 20yd Shuttle A2",
        "Three Cone A1",
        "Vid: Three Cone A1",
        "Three Cone A2",
        "Vid: Three Cone A2",
      ];

      const rows = data.map((a) => [
        a.firstName ?? "",
        a.lastName ?? "",
        a.jerseyNumber ?? "",
        yn(a.hasProfilePicture),
        yn(a.measurements?.height),
        yn(a.measurementVideos?.height),
        yn(a.measurements?.weight),
        yn(a.measurements?.wingspan),
        yn(a.measurementVideos?.wingspan),
        yn(a.measurementVideos?.overheadSquat),
        yn(a.measurements?.hand),
        yn(a.measurements?.foot),
        yn(a.combineResults?.fortyYardDash_Attempt1_10yd),
        yn(a.combineVideos?.fortyYardDash_Attempt1_10yd),
        yn(a.combineResults?.fortyYardDash_Attempt1_20yd),
        yn(a.combineResults?.fortyYardDash_Attempt1_40yd),
        yn(a.combineVideos?.fortyYardDash_Attempt1_40yd),
        yn(a.combineResults?.fortyYardDash_Attempt2_10yd),
        yn(a.combineVideos?.fortyYardDash_Attempt2_10yd),
        yn(a.combineResults?.fortyYardDash_Attempt2_20yd),
        yn(a.combineResults?.fortyYardDash_Attempt2_40yd),
        yn(a.combineVideos?.fortyYardDash_Attempt2_40yd),
        yn(a.combineResults?.benchPress),
        yn(a.combineVideos?.benchPress),
        yn(a.combineResults?.verticalJump),
        yn(a.combineVideos?.verticalJump),
        yn(a.combineResults?.broadJumpAttempt1),
        yn(a.combineVideos?.broadJumpAttempt1),
        yn(a.combineResults?.broadJumpAttempt2),
        yn(a.combineVideos?.broadJumpAttempt2),
        yn(a.combineResults?.twentyYardShuttleAttempt1),
        yn(a.combineVideos?.twentyYardShuttleAttempt1),
        yn(a.combineResults?.twentyYardShuttleAttempt2),
        yn(a.combineVideos?.twentyYardShuttleAttempt2),
        yn(a.combineResults?.threeConeAttempt1),
        yn(a.combineVideos?.threeConeAttempt1),
        yn(a.combineResults?.threeConeAttempt2),
        yn(a.combineVideos?.threeConeAttempt2),
      ]);

      const csvContent = [headers, ...rows]
        .map((row) =>
          row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(","),
        )
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${eventName ?? "event"}_audit.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading audit list:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const handlePaymentMethodSelect = async (method) => {
    try {
      let registrationUrl = `${process.env.REACT_APP_QR_CODE_ATHLETE_REGISTER_URL}${eventId}`;

      if (method === "cash") {
        const response = await GetCashToken(apiInstance);
        const cashToken = response.data.data;
        registrationUrl += `?cashToken=${cashToken}`;
      }

      setQrCodeUrl(registrationUrl);
      setIsOpen(true);
    } catch (error) {
      console.error("Error generating cash token:", error);
    } finally {
      setIsPaymentModalOpen(false);
    }
  };

  return (
    <>
      <div className="mb-4 mt-0 px-4 py-4 pt-0">
        <div className="flex justify-between items-center pb-3">
          <h1 className="uppercase text-xl">Athletes</h1>

          {eventId !== undefined && (
            <div className="flex items-center gap-6">
              <div className="relative" ref={actionMenuRef}>
                <button
                  type="button"
                  onClick={() => setIsActionMenuOpen((prev) => !prev)}
                  className="px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-md border hover:text-gray-700 hover:bg-gray-200 flex items-center gap-2"
                  aria-haspopup="menu"
                  aria-expanded={isActionMenuOpen}
                >
                  <span>Actions</span>
                  <FontAwesomeIcon icon={faChevronDown} className="text-xs" />
                </button>

                {isActionMenuOpen && (
                  <div
                    className="absolute right-0 z-20 mt-2 min-w-48 rounded-md border bg-white shadow-lg"
                    role="menu"
                  >
                    <button
                      type="button"
                      onClick={() => {
                        setOpen(true);
                        setIsActionMenuOpen(false);
                      }}
                      className="w-full px-4 py-3 text-sm text-gray-700 hover:bg-slate-100 flex items-center text-left"
                      role="menuitem"
                    >
                      <FontAwesomeIcon icon={faAddressCard} />
                      <span className="pl-2">Contact Info</span>
                    </button>

                    <button
                      className="w-full px-4 py-3 text-sm text-gray-700 hover:bg-slate-100 flex items-center text-left"
                      onClick={() => {
                        setEmailOpen(true);
                        setIsActionMenuOpen(false);
                      }}
                      type="button"
                      role="menuitem"
                    >
                      <FontAwesomeIcon icon={faEnvelope} />
                      <span className="pl-2">Send Email</span>
                    </button>

                    <button
                      className="w-full px-4 py-3 text-sm text-gray-700 hover:bg-slate-100 flex items-center text-left disabled:cursor-not-allowed disabled:text-gray-400"
                      onClick={() => {
                        setIsActionMenuOpen(false);
                        handleDownloadCsv();
                      }}
                      disabled={isDownloading}
                      type="button"
                      role="menuitem"
                    >
                      <FontAwesomeIcon icon={faDownload} />
                      <span className="pl-2">
                        {isDownloading ? "Downloading..." : "Audit CSV"}
                      </span>
                    </button>
                  </div>
                )}
              </div>

              {open && (
                <AthleteContactModal
                  attendees={attendees}
                  eventName={eventName}
                  onClose={() => setOpen(false)}
                />
              )}

              <FontAwesomeIcon
                icon={faPlus}
                size="sm"
                className="bg-[#5057FF] text-white p-2 rounded cursor-pointer"
                onClick={() => setIsPaymentModalOpen(true)}
              />
            </div>
          )}
        </div>

        {/* Search OUTSIDE header */}
        <input
          type="text"
          onChange={handleSearch}
          placeholder="Search Athletes..."
          className="border p-2 mb-0 w-full rounded-md"
        />
        <div
          className="mt-4 pr-4 -mr-4 overflow-auto"
          style={{ height: `${adjustedHeight}px` }}
        >
          <ul className="list-none p-0 mt-0">
            {attendeesList.length > 0 ? (
              attendeesList.map((athlete, index) => (
                <li
                  key={index}
                  className="cursor-pointer p-2 hover:bg-gray-200 border-slate-500 border mt-2 rounded-md px-3 shrink-0"
                  onClick={() => {
                    dispatch(
                      setAttendees({
                        eventId: eventId,
                        userAthlete: athlete,
                        eventAttendees: attendees,
                      }),
                    );
                    handleAttendeesClick(true);
                  }}
                >
                  <div className="flex justify-between items-center">
                    <div className="flex flex-row text-sm flex-1 space-x-3">
                      <div className="my-auto rounded-md">
                        <img
                          alt="Athlete Name"
                          src={
                            athlete.profilePicture || "/default-profile-img.png"
                          }
                          className="grow-0 shrink-0 rounded-md h-[40px] w-[40px]"
                        />
                      </div>
                      <div>
                        <span className="text-base uppercase font-semibold flex items-center gap-3">
                          {athlete.jerseyNumber &&
                          athlete.jerseyNumber !== "null"
                            ? `(#${athlete.jerseyNumber}) `
                            : ""}
                          {athlete.name} {athlete.lastname}{" "}
                          {athlete?.tShirtSize !== null && (
                            <span className="t-shirt w-[3.7rem] pl-1">
                              <p className="text-white text-[9px] font-bold pl-5 relative -top-0.5">
                                {" "}
                                {athlete?.tShirtSize}{" "}
                              </p>{" "}
                            </span>
                          )}
                        </span>

                        <div className="flex items-center gap-2 mt-1">
                          <p className="text-sm text-gray-700">
                            {athlete.position}
                          </p>
                        </div>
                      </div>
                      <div className="ml-6">
                        {athlete.hasPositionDrills && (
                          <p className="inline-flex items-center px-1.5 py-0.5  rounded-full text-xs font-semibold leading-4 bg-green-500 text-white">
                            P
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="flex">
                      <div className="my-auto h-[40px] w-[40px] bg-blue-700 text-center text-white rounded-md mr-5 hidden">
                        <p className="my-auto text-base mt-2">
                          {athlete.positionScore}
                        </p>
                      </div>
                      <button className="p-2 rounded">
                        <FontAwesomeIcon
                          icon={faChevronRight}
                          className="text-2xl font-bold"
                        />
                      </button>
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <div className="mt-4 text-center text-md text-slate-600">
                <div className="w-full p-2 mt-5 flex flex-col items-center">
                  <img
                    alt="No events that match your search"
                    src="/nodata.gif"
                    className="object-cover h-20 w-20 rounded-full border-gray-300 border"
                  />
                  <span className="mt-4 text-center text-md text-slate-600">
                    There are no records
                  </span>
                </div>
              </div>
            )}
          </ul>
        </div>
      </div>

      {/* Payment Method Modal */}
      <Dialog
        open={isPaymentModalOpen}
        onClose={() => setIsPaymentModalOpen(false)}
        className="relative z-50"
      >
        <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
        <div className="fixed inset-0 flex items-center justify-center">
          <DialogPanel className="w-96 border bg-white rounded-lg p-8">
            <DialogTitle className="text-xl font-semibold text-center">
              Select Payment Method
            </DialogTitle>
            <div className="flex flex-col items-center mt-4 space-y-4">
              <button
                className="w-full py-2 border border-black rounded hover:bg-gray-100"
                onClick={() => handlePaymentMethodSelect("cash")}
              >
                Paying with Cash
              </button>
              <button
                className="w-full py-2 border border-black rounded hover:bg-gray-100"
                onClick={() => handlePaymentMethodSelect("credit")}
              >
                Paying with Credit
              </button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>

      {/* QR Code Modal */}
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className="relative z-50"
      >
        <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
        <div className="fixed inset-0 flex w-screen items-center justify-center">
          <DialogPanel className="w-96 border bg-white rounded-lg p-8">
            <DialogTitle className="font-medium text-lg text-[#5057FF] text-center pt-4">
              {eventName} <span className="text-gray-800">Combine</span>
            </DialogTitle>
            <Description>
              <div className="flex items-center justify-center">
                <QRCodeCanvas value={qrCodeUrl} size={250} className="p-4" />
              </div>
            </Description>
            <p className="text-center mt-0 text-base text-gray-600">
              Scan the QR code to register
            </p>
            <div className="flex gap-4 pt-6 items-center justify-center">
              <button onClick={() => setIsOpen(false)}>Cancel</button>
            </div>
          </DialogPanel>
        </div>
      </Dialog>
      <SendEmailModal
        open={emailOpen}
        onClose={() => setEmailOpen(false)}
        attendees={attendees || []}
        eventId={eventId}
        eventName={eventName}
      />
    </>
  );
}
